import BaseModelAPI from '../BaseModelAPI';

export default class CombineCaseList extends BaseModelAPI {

	static entity = 'combinecaselist'
	static entityName = 'combinecase';

	constructor() {
		this.pageIndex = 0;
		this.pageSize = 0;
		this.pageCount = 0;
		this.dataCount = 0;
	}
}
